import { Component, inject, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BaseComponent } from 'components/base/base.component';
import { CardArquivoAnexadoComponent } from 'components/card-arquivo-anexado/card-arquivo-anexado.component';
import { ModalComponent } from 'components/modal/modal.component';
import { StarRatingConvivaComponent } from 'components/star-rating/star-rating.component';
import { VisualizarArquivoComponent } from 'components/visualizar-arquivo/visualizar-arquivo.component';
import { lastValueFrom } from 'rxjs';
import { ArquivoAzure } from 'src/app/shared/models/arquivo/ArquivoAzure';
import {
  JornadaPsicologo,
  JornadaPsicologoAtividade,
} from 'src/app/shared/models/psicologo/JornadaPsicologo';
import { ArquivoService } from 'src/app/shared/services/arquivo.service';
import { PsicologoUtilsService } from 'src/app/shared/services/psicologo-utils.service';
import { angularCommonImports } from 'src/app/shared/ui/angular-common';
import { convivaCommonImports } from 'src/app/shared/ui/conviva-common';
import { libsCommonImports } from 'src/app/shared/ui/libs-common';

@Component({
  selector: 'app-visualizar-jornada-atividade',
  templateUrl: './visualizar-jornada-atividade.component.html',
  styleUrls: ['./visualizar-jornada-atividade.component.scss'],
  standalone: true,
  imports: [
    angularCommonImports,
    convivaCommonImports,
    libsCommonImports,
    CardArquivoAnexadoComponent,
    VisualizarArquivoComponent,
    ModalComponent,
    StarRatingConvivaComponent,
  ],
})
export class VisualizarJornadaAtividadeComponent
  extends BaseComponent
  implements OnInit
{
  activatedRoute = inject(ActivatedRoute);
  psicologoUtilsService = inject(PsicologoUtilsService);
  arquivoService = inject(ArquivoService);

  jornadaId?: number;
  atividadeId?: number;
  jornada?: JornadaPsicologo;
  totalHorasTrabalhadas?: Date;
  showModalVisualizarArquivo = false;
  arquivoVisualizando?: ArquivoAzure;
  colunasGridTurma = [
    {
      title: 'Codigo Turma',
      field: 'codigoTurma',
      width: 200,
      hozAlign: 'center',
      headerHozAlign: 'center',
    },
    {
      title: 'Numero Classe',
      field: 'numeroClasse',
      width: 300,
      hozAlign: 'center',
      headerHozAlign: 'center',
    },
    {
      title: 'Tipo de Ensino',
      field: 'nomeTipoEnsino',
      width: 200,
      hozAlign: 'center',
      headerHozAlign: 'center',
    },
    {
      title: 'Numero Serie',
      field: 'numeroSerie',
      width: 300,
      hozAlign: 'center',
      headerHozAlign: 'center',
    },
  ];
  colunasGridOutros = [
    {
      title: 'Outros',
      field: 'outros',
      hozAlign: 'center',
      headerHozAlign: 'center',
    },
  ];
  colunasGridEquipeEscolar = [
    {
      title: 'Equipe Escolar ',
      field: 'nomeEquipeEscolar',
      hozAlign: 'center',
      headerHozAlign: 'center',
    },
  ];

  ngOnInit(): void {
    (async () => {
      this.spinnerService.show();
      this.setJornadaId();
      if (!this.jornadaId) {
        this.toastr.error('ID da jornada não informado.');
        this.spinnerService.hide();
        return;
      }

      await this.getJornadaPorId(this.jornadaId);

      this.spinnerService.hide();
    })();
  }

  setJornadaId() {
    this.activatedRoute.queryParams.subscribe((params) => {
      this.jornadaId = params.id;
      this.atividadeId = params.atividade;
    });
  }

  async getJornadaPorId(id: number) {
    const response = await lastValueFrom(
      this.psicologoService.getJornadaPorId(id),
    );
    if (!response.isSucess) {
      this.toastr.error(response.message, response.title);
      return;
    }

    this.jornada = response.data;
    for (const atividade of this.jornada!.atividades) {
      if (
        atividade.codigoAgendamento &&
        atividade.codigoAgendamento > 0 &&
        atividade.tipoAtividade == 4
      ) {
        const response = await lastValueFrom(
          this.psicologoService.getEnvolvidosPrevencaoPorCodigoAgendamento(
            atividade.codigoAgendamento,
          ),
        ).catch((error) => this.convivaErrors.handleResultError(error));
        if (!response.isSucess) {
          this.toastr.error(response.message, response.title);
          return;
        }
        atividade.envolvidos = response.data;
      }
    }

    this.calculaTotalHorasTrabalhadas();
    this.toastr.success('Jornada encontrada com sucesso!');
  }
  calculaTotalHorasTrabalhadas() {
    this.totalHorasTrabalhadas =
      this.psicologoUtilsService.calculaTotalHorasTrabalhadas(this.jornada);
  }

  getTipoAtividade(tipoAtividade: number): string {
    switch (tipoAtividade) {
      case 1:
        return 'Acolhimento Não Agendado';
      case 2:
        return 'Acolhimento Agendado';
      case 3:
        return 'Prevenção Não Agendado';
      case 4:
        return 'Prevenção Agendado';
      default:
        return '';
    }
  }
  hasTipoPessoa(
    atividade: JornadaPsicologoAtividade | any,
    tipoPessoa: number,
  ): boolean {
    return atividade.envolvidos.some(
      (envolvido: any) => envolvido.tipoPessoa === tipoPessoa,
    );
  }

  public async DownloadArquivo(arquivo: ArquivoAzure) {
    this.spinnerService.show();
    try {
      const response = await lastValueFrom(
        this.arquivoService.getArquivoPorNome(arquivo.nome),
      );

      const url = globalThis.URL.createObjectURL(response);
      const link = document.createElement('a');
      link.href = url;
      link.download = arquivo.nomeOriginal || arquivo.nome;
      link.click();
      globalThis.URL.revokeObjectURL(url);

      this.toastr.success('Arquivo baixado com sucesso!');
    } catch (error) {
      console.error('Erro ao baixar arquivo:', error);
      this.toastr.error('Erro ao baixar o arquivo');
    } finally {
      this.spinnerService.hide();
    }
  }

  public visualizarAquivo(
    index: number,
    atividade: JornadaPsicologoAtividade | any,
  ): void {
    if (index >= 0 && atividade.arquivos && index < atividade.arquivos.length) {
      this.arquivoVisualizando = this.getArquivoAzure(
        atividade.arquivos[index],
      );
      this.showModalVisualizarArquivo = true;
    }
  }

  public fecharModalVisualizarArquivo(): void {
    this.showModalVisualizarArquivo = false;
    this.arquivoVisualizando = undefined;
  }

  public getArquivoAzure(arquivo: any): ArquivoAzure {
    return {
      nome: arquivo.nomeArquivo,
      caminhoAzure: arquivo.caminhoArquivo,
      conteudo: '',
      ehBase64: false,
      dataOperacao: arquivo.dataOperacao,
      nomeOriginal: arquivo.nomeArquivoOriginal,
    };
  }
}
